// Helpers for recognizing who a device's SIM card belongs to.
//
// Naviter ships devices with SIM cards from Onomondo (a Danish provider), whose
// ICCIDs are issued under the 894573 IIN (89 = telecom, 45 = Denmark, 73 = Onomondo).
// Example of a Naviter SIM: 89457300000035900201
// Anything else was supplied by the customer, so we can't tell whose it is.

export const ONOMONDO_ICCID_PREFIXES = ['894573'];

export const SIM_CARD_OWNERS = {
  onomondo: {
    key: 'onomondo',
    label: 'Onomondo Naviter',
    className: 'bg-green-100 text-green-800'
  },
  unknown: {
    key: 'unknown',
    label: 'Unknown SIM card',
    className: 'bg-gray-100 text-gray-800'
  }
};

// True for attribute names like "SIM ICCID", "iccid", "SIM_ICCID"
export const isIccidAttribute = (attributeName) => /iccid/i.test(attributeName || '');

// ICCIDs are sometimes entered with spaces or dashes
export const normalizeIccid = (value) => String(value ?? '').replace(/\D/g, '');

// SIM management for our own (Onomondo) cards lives in the SeeYou Cloud admin
export const SEEYOU_SIM_ADMIN_URL = 'https://admin.seeyou.cloud/sims';

// Returns one of SIM_CARD_OWNERS, or null when there is no ICCID to classify
export const getSimCardOwner = (iccid) => {
  const normalized = normalizeIccid(iccid);
  if (!normalized) return null;
  return ONOMONDO_ICCID_PREFIXES.some((prefix) => normalized.startsWith(prefix))
    ? SIM_CARD_OWNERS.onomondo
    : SIM_CARD_OWNERS.unknown;
};

// Admin link for our own SIM cards; null for customer-supplied ones
export const getSimAdminUrl = (iccid) => {
  const normalized = normalizeIccid(iccid);
  const owner = getSimCardOwner(normalized);
  if (!owner || owner.key !== 'onomondo') return null;
  return `${SEEYOU_SIM_ADMIN_URL}/${normalized}`;
};
